<script>

import HomePage from '@/pages/HomePage'
import LoginPage from '@/pages/LoginPage'
import Page404 from '@/pages/Page404'
import LogoutPage from '@/pages/LogoutPage'
import RecoveryPage from '@/pages/RecoveryPage'
import RecoveryNewPassPage from '@/pages/RecoveryNewPassPage'

import TutorialStep1Page from '@/pages/TutorialStep1Page'
import TutorialStep2Page from '@/pages/TutorialStep2Page'
import TutorialStep3Page from '@/pages/TutorialStep3Page'

import ProfilePage from '@/pages/ProfilePage'
import SupportPage from '@/pages/SupportPage'
import SearchPage from '@/pages/SearchPage'
import PillsVideoPage from '@/pages/PillsVideoPage'
import PillsAudioPage from '@/pages/PillsAudioPage'
import PillsPdfPage from '@/pages/PillsPdfPage'
import PillsTextPage from '@/pages/PillsTextPage'
import PillsImagePage from '@/pages/PillsImagePage'
import PillsErrorPage from '@/pages/PillsErrorPage'
import PillsIncompletePage from '@/pages/PillsIncompletePage'
import PillsCompletadoPage from '@/pages/PillsCompletadoPage'

const routes = [
    { path: '/', name: 'home', component: HomePage },
    { path: '/login', name: 'login', component: LoginPage },
    { path: '/logout', name: 'logout', component: LogoutPage },
    { path: '/recovery', name: 'recovery', component: RecoveryPage },
    { path: '/recovery-new-pass', name: 'recovery_new_pass', component: RecoveryNewPassPage },

    { path: '/tutorial-step-1', name: 'tutorial_step_1', component: TutorialStep1Page },
    { path: '/tutorial-step-2', name: 'tutorial_step_2', component: TutorialStep2Page },
    { path: '/tutorial-step-3', name: 'tutorial_step_3', component: TutorialStep3Page },

    { path: '/profile', name: 'profile', component: ProfilePage },
    { path: '/support', name: 'support', component: SupportPage },
    { path: '/search', name: 'search', component: SearchPage },
    { path: '/pills-video', name: 'pills_video', component: PillsVideoPage },
    { path: '/pills-audio', name: 'pills_audio', component: PillsAudioPage },
    { path: '/pills-pdf', name: 'pills_pdf', component: PillsPdfPage },
    { path: '/pills-text', name: 'pills_text', component: PillsTextPage },
    { path: '/pills-image', name: 'pills_image', component: PillsImagePage },
    { path: '/pills-incomplete', name: 'pills_incomplete', component: PillsIncompletePage },
    { path: '/pills-error', name: 'pills_error', component: PillsErrorPage },
    { path: '/pills-completado', name: 'pills_completado', component: PillsCompletadoPage },

    { path: '*', component: Page404 }

]

export default routes; 

</script>
